export const typedKeys = <T extends object>(o: T | null | undefined): Array<keyof T> => {
  if (o == null) {
    return [];
  }
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return Object.keys(o) as Array<keyof T>;
};

type FunctionType<A, K = string> = (value: A, key: K) => boolean;
type ObjectType<V> = Record<string, V>;

export function objectSome<A, O extends ObjectType<A>>(
  input: O,
  cb: FunctionType<A, keyof O>,
): boolean {
  return typedKeys(input)
    .map((key) => cb(input[key], key))
    .some((el) => el === true);
}

export function objectEvery<A, O extends ObjectType<A>>(
  input: O,
  cb: FunctionType<A, keyof O>,
): boolean {
  return typedKeys(input)
    .map((key) => cb(input[key], key))
    .every((el) => el === true);
}

type ObjectTypeWithNumberKey<V> = Record<number, V>;

export function isEmptyObject<O>(input: ObjectType<O> | ObjectTypeWithNumberKey<O>): boolean {
  return Object.keys(input).length === 0;
}
